import gateway from "./gateway";
import mq from "./mq";

export default { mq: mq(gateway) };
